import React from 'react';
import {
  compose,
  setDisplayName,
  withProps,
} from 'recompose';
import reactCSS from 'reactcss';
import Panel from '@ux/panel';
import { withUniqueId } from '@team-griffin/react-unique-id';
import { H } from '@team-griffin/react-heading-section';
import { Field } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { ReduxFormSwitch } from '@ux/switch';
import { ShowWhen } from '@ux/render-logic';
import { getStyles } from '@ux/style-utils';
import stylesheet from './CookieToggle.stylesheet';

const stylesheetToStyles = (stylesheet, props) => reactCSS(stylesheet, {
  canOptOut: props.canOptOut,
});

const PureCookieToggle = ({
  theme,
  styles,
  name,
  canOptOut,
  id,
}) => (
  <Panel
    theme={theme}
    style={styles.panel}
  >
    <label
      style={styles.root}
      htmlFor={id}
    >
      <div style={styles.toggle}>
        <H
          depth={3}
          style={styles.title}
        >
          <FormattedMessage id={`cookie.toggle.${name}.title`}/>
        </H>

        <ShowWhen test={canOptOut}>
          <Field
            name={name}
            id={id}
            component={ReduxFormSwitch}
            theme={theme}
          />
        </ShowWhen>
      </div>
      <p style={styles.text}>
        <FormattedMessage id={`cookie.toggle.${name}.text`}/>
      </p>
    </label>
  </Panel>
);


export const enhance = compose(
  setDisplayName('CookieToggle'),
  withProps((ownerProps) => ({
    styles: getStyles(stylesheet, stylesheetToStyles, ownerProps),
  })),
  withUniqueId({
    prefix: 'cookie_',
  }),
);

export default enhance(PureCookieToggle);



// WEBPACK FOOTER //
// ./src/presentation/components/cookie-toggle/CookieToggle.js